<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="tracking-timeline">
    <div class="tracking-header">
      <a-form :form="form" layout="horizontal">
        <a-row type="flex" justify="center">
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Nama Pengirim">
              <span class="ant-form-text">{{shipment.vSenderName}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Nama Penerima">
              <span class="ant-form-text">{{shipment.vDestName}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Tanggal">
              <span class="ant-form-text">{{shipment.pickupDate}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Kota Asal">
              <span class="ant-form-text">{{shipment.vSenderCity}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Kota Tujuan">
              <span class="ant-form-text">{{shipment.vDestCity}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="timeline-form" v-bind="formItemLayout" label="Coly">
              <span class="ant-form-text">{{shipment.iColi}}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="tracking-divider"/>
    <div class="tracking-detail">
      <a-timeline mode="alternate">
        <a-timeline-item v-for="(track, index) in shipment.tracking" :key="track.id" color="purple">
          <a-avatar
            slot="dot"
            :size="38"
            :src="trackStatusInfo[track.cTrackStatus].iconImage"
            style="border:1px solid #eee;border-radius:100px;padding:8px;background:#eee;"
          />
          <div :class="'timeline-box '+trackStatusInfo[track.cTrackStatus].borderClass">
            <a-row v-if="index%2==0" type="flex" justify="start">
              <a-col
                :xs="{ span: 24}"
                :sm="{ span: 4}"
                :md="{ span: 4}"
                :lg="{ span: 4}"
                :xl="{ span: 4}"
                :order="1"
              >
                <a-avatar
                  class="timeline-image"
                  shape="square"
                  :size="55"
                  :src="trackStatusInfo[track.cTrackStatus].image"
                />
              </a-col>
              <a-col
                :xs="{ span: 24}"
                :sm="{ span: 20}"
                :md="{ span: 20}"
                :lg="{ span: 20}"
                :xl="{ span: 20}"
                :order="2"
              >
                <div class="timeline-box-header">{{track.trackDate}}</div>
                <div class="timeline-box-content" v-html="track.description"/>
              </a-col>
            </a-row>
            <a-row v-else type="flex" justify="end">
              <a-col
                :xs="{ span: 24}"
                :sm="{ span: 4}"
                :md="{ span: 4}"
                :lg="{ span: 4}"
                :xl="{ span: 4}"
                :order="2"
              >
                <a-avatar
                  class="timeline-image"
                  shape="square"
                  :size="55"
                  :src="trackStatusInfo[track.cTrackStatus].image"
                />
              </a-col>
              <a-col
                :xs="{ span: 24}"
                :sm="{ span: 20}"
                :md="{ span: 20}"
                :lg="{ span: 20}"
                :xl="{ span: 20}"
                :order="1"
              >
                <div class="timeline-box-header">{{track.trackDate}}</div>
                <div class="timeline-box-content" v-html="track.description"/>
              </a-col>
            </a-row>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
</template>

<script>
export default {
  props: ["shipment"],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },

      trackStatusInfo: {
        PU: {
          image: require("@/assets/shipments/status_PU.png"),
          borderClass: "border-start",
          iconImage: require("@/assets/shipments/icons/bullseye.png")
        },
        AO: {
          image: require("@/assets/shipments/status_AO.png"),
          borderClass: "border-normal",
          iconImage: require("@/assets/shipments/icons/dot-and-circle.png")
        },
        OB: {
          image: require("@/assets/shipments/status_OB_LAND.png"),
          borderClass: "border-normal",
          iconImage: require("@/assets/shipments/icons/right-arrow-in-a-circle.png")
        },
        AF: {
          image: require("@/assets/shipments/status_AF.png"),
          borderClass: "border-normal",
          iconImage: require("@/assets/shipments/icons/dot-and-circle.png")
        },
        WC: {
          image: require("@/assets/shipments/status_WC.png"),
          borderClass: "border-normal",
          iconImage: require("@/assets/shipments/icons/right-arrow-in-a-circle.png")
        },
        OK: {
          image: require("@/assets/shipments/status_OK.png"),
          borderClass: "border-end",
          iconImage: require("@/assets/shipments/icons/check-mark.png")
        }
      }
    };
  }
};
</script>

<style>
.tracking-timeline {
  padding: 0 20px;
}

.tracking-header {
  padding: 10px;
}

.tracking-detail {
  margin-top: 10px;
  padding: 0 50px;
}

.tracking-divider {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  margin-bottom: 30px;
}

.ant-form-text {
  margin-left: 10px;
}

.ant-form-item-label {
  font-weight: 600;
}

.timeline-box {
  padding: 10px;
  border-radius: 8px;
  max-width: 550px;
}

.ant-timeline-item-left .timeline-box {
  margin-left: 15px;
}
.ant-timeline-item-right .timeline-box {
  margin-right: 15px;
}

.border-normal {
  border: 2px solid #c4cfd6;
}

.border-start {
  border: 2px solid #023e97;
}

.border-end {
  border: 2px solid #1fba1f;
}

.timeline-box-header {
  font-weight: 600;
}

.timeline-image {
  text-align: center;
}

.timeline-form {
  margin-bottom: 0px !important;
}
</style>